import { v4 as uuidv4 } from "uuid";
export class CyclesListingModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.description = "";
        this.pmoTeamId = uuidv4();
        this.period = "";
        this.createdBy = uuidv4();
        this.paCycleReviewAssignments = [];
        this.paCycleStatusSummary = [];
    }
}
export default class CyclesListing extends CyclesListingModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
